<template>
    <div>
        <eg-modal height="300px" :width="isMobile ? '97%' : '800px'" :show="show" @close="$emit('close', false)">
            <p class="center" slot="header">
                <b>Em uma escala de 0 a 10, qual a chance de você recomendar a Engelink para um amigo?</b>
            </p>
            <div slot="body">
                <div class="rating-wrapper">
                    <div
                        v-for="rating in 11"
                        :key="rating - 1"
                        :class="[
                            'rating rating-' + (rating - 1),
                            {
                                inactive: userRatingForm.rating !== '' && userRatingForm.rating !== rating - 1,
                            },
                        ]"
                        @click="setRating(rating - 1)"
                    >
                        {{ rating - 1 }}
                    </div>
                </div>
                <div class="input-field textarea-field">
                    <span>Escreva seu comentário abaixo (opcional)</span>
                    <textarea
                        id="user-rating-message"
                        v-model.trim="userRatingForm.message"
                        class="materialize-textarea"
                    ></textarea>
                </div>
            </div>
            <div slot="footer">
                <eg-button
                    class="modal-action"
                    @click="sendRating"
                    :disabled="disableSendRating || !userRatingForm.rating != ''"
                >
                    Enviar
                </eg-button>
            </div>
        </eg-modal>
        <eg-modal height="300px" width="800px" :show="successModal" @close="successModal = $event">
            <p class="center" slot="header">
                <b style="color: green">Sucesso</b>
            </p>
            <p slot="body">Obrigado, a Engelink agradece a sua avaliação</p>
        </eg-modal>
    </div>
</template>

<script>
import { sendRating } from '@/services/api/invite';
export default {
    name: 'RatingUser',
    data: () => ({
        disableSendRating: false,
        userRatingForm: {
            rating: '',
            message: ''
        },
        successModal: false
    }),
    props: {
        show: {
            type: Boolean,
            default: false
        },
        isMobile: [Boolean, Object]
    },
    methods: {
        async sendRating() {
            try {
                this.disableSendRating = true;
                const data = {
                    rating: this.userRatingForm.rating,
                    text_feedback: this.userRatingForm.message
                };
                await sendRating(data);
                this.$emit('close', false);
                this.successModal = true;
            } catch (error) {
                console.error(error);
                this.disableSendRating = false;
            }
        },
        setRating(rating) {
            this.$set(this.userRatingForm, 'rating', rating);
        }
    }
};
</script>

<style scoped>
.rating-wrapper {
    align-items: center;
    display: flex;
    justify-content: center;
}
.rating {
    background-color: #002b4d;
    border-radius: 5px;
    color: #fff;
    cursor: pointer;
    margin-right: 10px;
    padding: 12px;
    text-align: center;
    width: 49px;
    opacity: 1;
}
.rating.inactive {
    opacity: 0.4;
}
.rating:last-child {
    margin-right: 0;
}
.rating-0 {
    background-color: #b62124;
}
.rating-1 {
    background-color: #d72027;
}
.rating-2 {
    background-color: #eb5526;
}
.rating-3 {
    background-color: #f37021;
}
.rating-4 {
    background-color: #faa823;
}
.rating-5 {
    background-color: #ffca27;
}
.rating-6 {
    background-color: #ecdb12;
}
.rating-7 {
    background-color: #d8d736;
}
.rating-8 {
    background-color: #c5d92d;
}
.rating-9 {
    background-color: #afd136;
}
.rating-10 {
    background-color: #64b64d;
}

#user-rating-modal .content {
    align-items: center;
    display: flex;
    flex-direction: column;
}
#user-rating-modal .modal-close {
    align-self: flex-end;
}

#user-rating-modal .textarea-field {
    width: 34%;
    margin-top: 34px;
}

#user-rating-modal .textarea-field span {
    font-size: 18px;
}

#user-rating-message {
    padding-top: 6px !important;
    font-size: 18px;
}

#user-rating-modal .modal-footer {
    text-align: center !important;
}

@media screen and (max-width: 768px) {
    .rating-wrapper {
        align-items: center;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
    }
    .rating {
        margin-top: 10px;
        width: 39px;
        margin-right: 7px;
    }

    #user-rating-modal .textarea-field {
        width: 100%;
    }

    #user-rating-modal .modal-close {
        align-self: flex-end;
        position: absolute;
        right: 10px;
        top: 8px;
    }
}
</style>
